iScreenWizard.factory('Gebruiker', function ($q, Ajax) {

    var data = {};

    data.all = function() {
        return $q(function (resolve, reject) {
            Ajax.get('gebruiker').then(function (response) {
                var gebruikers = response.data;
                resolve(gebruikers);
            }, reject);
        });
    };

    data.get = function(id) {
        return $q(function (resolve, reject) {
            Ajax.get('gebruiker/'+id).then(function (response) {
                var gebruiker = response.data;
                resolve(gebruiker);
            }, reject);
        });
    };

    return data;
});